export default __webpack_public_path__ + "static/media/frontend.2622ccf6.png";